require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('./lineChartMultiple.styl');

import React from 'react';
import Tooltip from '../tooltip/Tooltip';
// import ReactDOM from 'react-dom';
// import d3 from 'd3';

import {timeParse,timeFormat} from 'd3-time-format';
import {scaleLinear, scaleOrdinal, scaleTime} from 'd3-scale';
import {line, curveCatmullRom} from 'd3-shape';
import {extent, max, mean, median} from 'd3-array';
import {select as d3select} from 'd3-selection';
import {axisBottom as d3axisBottom, axisLeft as d3axisLeft} from 'd3-axis';
import {formatDefaultLocale,format} from 'd3-format';
// import {interpolate} from 'd3-interpolate';
// import {keys, nest} from 'd3-collection';

const localeDefinition = require('json!de-ch-locale');

/************************************************************************/

class LinechartMultiple extends React.Component {

  constructor(props) {
    super(props);

    this.mouseEntersDot= this.mouseEntersDot.bind(this);
    this.mouseLeavesDot= this.mouseLeavesDot.bind(this);
    this.touchStart= this.touchStart.bind(this);

    this.state= {
      width: this.props.width,
      height: this.props.height,
      showTooltip: false
    }

  }

  touchStart(e) {

    // console.log(e.target.getAttribute('cx'));

    let count = e.target.getAttribute('data-count');
    let year = e.target.getAttribute('data-year');
    let title = e.target.getAttribute('data-title');

    // show tooltip here
    this.setState({
      showTooltip: true,
      tooltipX: e.target.getAttribute('cx'),
      tooltipY: e.target.getAttribute('cy'),
      tooltipTitle: year,
      tooltipCount: count
    });

  }

  mouseEntersDot(e) {

    // DESKTOP AND TOUCH DEVICE SWITCH
    if (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0)) {
      return;
    } else {

      let count = e.target.getAttribute('data-count');
      let year = e.target.getAttribute('data-year');
      let title = e.target.getAttribute('data-title');

      // show tooltip here
      this.setState({
        showTooltip: true,
        tooltipX: e.target.getAttribute('cx'),
        tooltipY: e.target.getAttribute('cy'),
        tooltipTitle: year,
        tooltipCount: count
      });
    }

  }

  mouseLeavesDot() {
    // hide tooltip here
    this.setState({
      showTooltip: false
    })
  }

  render() {

    let dataSet = {
      p25: [],
      p50: [],
      p75: []
    }

    for(let i=0; i<this.props.dataSource.length; i++) {
      dataSet.p25.push({year: this.props.dataSource[i].year, count: this.props.dataSource[i].p25});
      dataSet.p50.push({year: this.props.dataSource[i].year, count: this.props.dataSource[i].p50});
      dataSet.p75.push({year: this.props.dataSource[i].year, count: this.props.dataSource[i].p75});
    }

    const data = dataSet;

    // to keep 'this' alive in the data.map function below
    const _self = this;

    let margin = {top: 15, right: 20, bottom: 20, left: 35};
    let w = this.props.width - margin.left - 2*margin.right;
    let h = this.props.width > 479 ?
      this.props.height - (margin.top + margin.bottom) : this.props.height/2 - (margin.top + margin.bottom),
      r = this.props.circleRadius;

    if(this.state.width < 500) {
      r = this.props.circleRadius * 1.2;
    }




    const locale = formatDefaultLocale(localeDefinition);

    data.p25.forEach(function(d) {
      d.yearTick = d.year.toString();
    });
    data.p50.forEach(function(d) {
      d.yearTick = d.year.toString();
    });
    data.p75.forEach(function(d) {
      d.yearTick = d.year.toString();
    });

    // console.log(data);

    // AXIS SETUP
    const x = scaleTime()
      .domain(extent([1999,2014]))
      .rangeRound([0, w]);

    const y = scaleLinear()
      .domain(
        [this.props.minY,this.props.maxY]
      )
      .range([h, 0]);

    let axisBottom = d3axisBottom(x)
      .ticks(this.props.ticksX)
      .tickSize(4)
      .tickFormat(format(".0f"));
    ;

    let axisLeft   = d3axisLeft(y)
      .ticks(this.props.ticksY)
      .tickSize(4)
      .tickFormat(function(d) { return parseInt(d, 10) + "%"; });
    ;

    // DRAW LINE IN CSV

    const drawLine = line()
      .x(function(d) {
        return x(d.year);
      })
      .y(function(d) {
        return y(d.count);
      })
      .curve(curveCatmullRom.alpha(0.5));

    const transform = 'translate(' + margin.left + ',' + margin.top + ')';

    return (

      <div
        className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded linechart ${this.props.chartClassName}`}
      >
        <div
          className='ui inverted simple dimmer'
        >
        </div>

        <svg
          id={`svg-${this.props.chartId}`}
          height={
            this.props.width > 479 ? this.props.height : this.props.height/2
          }
          width={
            this.props.width - 20
          }
        >
          <g
            transform={transform}
          >

            <g className='axes'
               transform='translate(0,0)'>
              <g className='axis-bottom'
                 ref={(el) => axisBottom(d3select(el))}
                 transform={`translate(0,${h})`}/>
              <g className='axis-left'
                 ref={(el) => axisLeft(d3select(el))}
                 transform='translate(0,0)'
              />
            </g>

            <path
              className='line shadow p25'
              d={drawLine(data.p25)} strokeLinecap='round'
            />

            <path
              className='line shadow p50'
              d={drawLine(data.p50)} strokeLinecap='round'
            />

            <path
              className='line shadow p75'
              d={drawLine(data.p75)} strokeLinecap='round'
            />

            const _self = this;

            // TODO Possibly error with direct attributes like strokeWidth when compiling in DIST
            // TODO Append transparent rect over circle for mouseover event trigger

            {data.p25.map(function(d,i) {
              return(
                <circle
                  className='dot'
                  r={r}
                  cx={x(d.year)}
                  cy={y(d.count)}
                  fill='#E23C4E'
                  stroke={_self.props.circleStrokeFill}
                  strokeWidth={_self.props.circleStroke}
                  key={i}
                  onMouseEnter={_self.mouseEntersDot}
                  onMouseLeave={_self.mouseLeavesDot}
                  onTouchStart={_self.touchStart}
                  data-count={Math.round(d.count*10)/10}
                  data-year={d.year}
                  data-title={d.count}
                />
              )
            })}

            {data.p50.map(function(d,i) {
              return(
                <circle
                  className='dot'
                  r={r}
                  cx={x(d.year)}
                  cy={y(d.count)}
                  fill='#1D5F82'
                  stroke={_self.props.circleStrokeFill}
                  strokeWidth={_self.props.circleStroke}
                  key={i}
                  onMouseEnter={_self.mouseEntersDot}
                  onMouseLeave={_self.mouseLeavesDot}
                  onTouchStart={_self.touchStart}
                  data-count={Math.round(d.count*10)/10}
                  data-year={d.year}
                  data-title={d.count}
                />
              )
            })}

            {data.p75.map(function(d,i) {
              return(
                <circle
                  className='dot'
                  r={r}
                  cx={x(d.year)}
                  cy={y(d.count)}
                  fill='black'
                  stroke={_self.props.circleStrokeFill}
                  strokeWidth={_self.props.circleStroke}
                  key={i}
                  onMouseEnter={_self.mouseEntersDot}
                  onMouseLeave={_self.mouseLeavesDot}
                  onTouchStart={_self.touchStart}
                  data-count={Math.round(d.count*10)/10}
                  data-year={d.year}
                  data-title={d.count}
                />
              )
            })}


            { this.state.showTooltip == true &&

            <Tooltip
              tooltipPosX={parseFloat(this.state.tooltipX)}
              tooltipPosY={parseFloat(this.state.tooltipY)}
              tooltipWidth={this.props.tooltipWidth}
              tooltipHeight={this.props.tooltipHeight}
              chartWidth={this.props.width - margin.left - margin.right}
              chartHeight={this.props.height}
              tooltipClassName='tooltip'
              tooltipBackground='#000000'
              tooltipColor='#ffffff'
              tooltipTitle={this.state.tooltipTitle}
              tooltipCount={this.state.tooltipCount}
              tooltipSize={this.props.linechartClass}
              tooltipFontSize={this.props.tooltipFontSize}
              tooltipPrefix={this.props.chartClassName == 'small' ? 'Jahr ' : 'Jahr '}
              tooltipSuffix={this.props.chartClassName == 'small' ? ' ' : ':'}
              tooltipCountSuffix={this.props.chartClassName == 'small' ? '' : ' Prozent'}
              tooltipCountPrefix={this.props.chartClassName == 'small' ? 'Total: ' : '' }
              tooltipCountAbsolutePrefix={this.props.chartClassName == 'small' ? 'Anteil: ' : '' }
              tooltipCountAbsoluteSuffix={this.props.chartClassName == 'small' ? '%' : '' }
              tooltipCountAbsolute={this.state.tooltipCount}
              tooltipCountPercentage={this.state.percentage}
              tooltipYOffset={5}
            />

            }

          </g>
        </svg>
      </div>
    );
  }
}

LinechartMultiple.propTypes = {
  chartTitle: React.PropTypes.string,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  chartId: React.PropTypes.string,
  chartClassName: React.PropTypes.string,
  linechartClass: React.PropTypes.string,
  readerMadeHisChoice: React.PropTypes.bool,
  circleFillp25: React.PropTypes.string,
  circleFillp50: React.PropTypes.string,
  circleFillp75: React.PropTypes.string,
  maxY: React.PropTypes.number,
  minY: React.PropTypes.number,
  circleStrokeFillp25: React.PropTypes.string,
  circleStrokeFillp50: React.PropTypes.string,
  circleStrokeFillp75: React.PropTypes.string,
  circleRadius: React.PropTypes.number,
  circleStroke: React.PropTypes.number,
  circleStrokeFill: React.PropTypes.string,
  ticksX: React.PropTypes.number,
  ticksY: React.PropTypes.number,
  tickFormatX: React.PropTypes.string,
  tickFormatY: React.PropTypes.string,
  x: React.PropTypes.func,
  y: React.PropTypes.func,
  tooltipWidth: React.PropTypes.number,
  tooltipHeight: React.PropTypes.number,
  tooltipFontSize: React.PropTypes.number,
  dataSource: React.PropTypes.array,
  chartMargin: React.PropTypes.array
}

export default LinechartMultiple;



// WEBPACK FOOTER //
// ./src/components/lineChartMultiple/LinechartMultiple.component.js